import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ContractListComponent } from '../../components';

import { ContractsService } from '../../contracts.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-customer-contracts-view',
    imports: [ContractListComponent],
    templateUrl: './customer-contracts-view.component.html',
    styleUrl: './customer-contracts-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerContractsViewComponent {
    public contracts = toSignal(inject(ContractsService).contracts$);
}
